import { toTagComparisonKey } from './UserTagEditor.logic';

// 入力候補として出す既存の責任者名。重複を除いて五十音順に並べる
export function getChiefNameSuggestions(existingChiefNames: string[]): string[] {
  return Array.from(new Set(existingChiefNames)).sort((a, b) => a.localeCompare(b, 'ja'));
}

/**
 * 入力した責任者名と表記だけが違う既存の責任者名を探す。比べ方はタグの表記ゆれと同じにする。
 * 既存の名前と1文字も違わないとき、空のとき、表記ゆれで同じ名前がないときは undefined を返す
 */
export function findSimilarChiefName(input: string, existingChiefNames: string[]): string | undefined {
  const name = input.trim();
  if (name === '' || existingChiefNames.indexOf(name) !== -1) {
    return undefined;
  }
  const key = toTagComparisonKey(name);
  return existingChiefNames.find(existingName => toTagComparisonKey(existingName) === key);
}
